import { inject, Injectable } from '@angular/core';
import { SharedMemberApi } from '../api/shared-member-api';
import { Observable } from 'rxjs';
import { ApplicationTaskAttachment } from '../models/attachment/application-task-attachment';
import { MembershipApplicationTask } from '../models/member/membership-application';
import { MemberEmployer } from '../models/member/member-employer';
import { OdataQueryOptions } from '../models/odata/odata-query-options';

@Injectable({
  providedIn: 'root',
})
export class SharedMemberRepository {
  private sharedMemberApi = inject(SharedMemberApi);

  updateMembershipApplicationTask(request: MembershipApplicationTask): Observable<MembershipApplicationTask> {
    return this.sharedMemberApi.updateMembershipApplicationTask(request, request.id ?? -1);
  }

  addMembershipApplicationTaskUpload(taskAttachment: ApplicationTaskAttachment): Observable<ApplicationTaskAttachment> {
    return this.sharedMemberApi.addMembershipApplicationTaskUpload(taskAttachment);
  }

  removeMembershipApplicationTaskUpload(applicationTaskId: number, uploadId: number): Observable<void> {
    return this.sharedMemberApi.removeMembershipApplicationTaskUpload(applicationTaskId, uploadId);
  }

  updateMembershipReinstatementApplicationTask(
    request: MembershipApplicationTask,
  ): Observable<MembershipApplicationTask> {
    return this.sharedMemberApi.updateMembershipReinstatementApplicationTask(request, request.id ?? -1);
  }

  addMembershipReinstatementApplicationTaskUpload(
    taskAttachment: ApplicationTaskAttachment,
  ): Observable<ApplicationTaskAttachment> {
    return this.sharedMemberApi.addMembershipReinstatementApplicationTaskUpload(taskAttachment);
  }

  removeMembershipReinstatementApplicationTaskUpload(applicationTaskId: number, uploadId: number): Observable<void> {
    return this.sharedMemberApi.removeMembershipReinstatementApplicationTaskUpload(applicationTaskId, uploadId);
  }

  updateMembershipReapplicationApplicationTask(
    request: MembershipApplicationTask,
  ): Observable<MembershipApplicationTask> {
    return this.sharedMemberApi.updateMembershipReapplicationApplicationTask(request, request.id ?? -1);
  }

  addMembershipReapplicationTaskUpload(
    taskAttachment: ApplicationTaskAttachment,
  ): Observable<ApplicationTaskAttachment> {
    return this.sharedMemberApi.addMembershipReapplicationTaskUpload(taskAttachment);
  }

  removeMembershipReapplicationTaskUpload(applicationTaskId: number, uploadId: number): Observable<void> {
    return this.sharedMemberApi.removeMembershipReapplicationTaskUpload(applicationTaskId, uploadId);
  }

  createMemberEmployer(memberId: number, request: MemberEmployer): Observable<MemberEmployer> {
    return this.sharedMemberApi.createMemberEmployer(memberId, request);
  }
  getMemberEmployerById(
    memberId: number,
    memberEmployerId: number,
    odataQueryOptions: OdataQueryOptions | null = null,
  ): Observable<MemberEmployer> {
    return this.sharedMemberApi.getMemberEmployerById(memberId, memberEmployerId, odataQueryOptions);
  }
  getMemberEmployers(memberId: number): Observable<MemberEmployer[]> {
    return this.sharedMemberApi.getMemberEmployers(memberId);
  }
  updateMemberEmployer(
    memberId: number,
    memberEmployerId: number,
    request: MemberEmployer,
  ): Observable<MemberEmployer> {
    return this.sharedMemberApi.updateMemberEmployer(memberId, memberEmployerId, request);
  }
}
